var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPerson = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14C15.8565 14 17.637 13.2625 18.9497 11.9497C20.2625 10.637 21 8.85651 21 7C21 5.14349 20.2625 3.36301 18.9497 2.05025C17.637 0.737498 15.8565 0 14 0C12.1435 0 10.363 0.737498 9.05025 2.05025C7.7375 3.36301 7 5.14349 7 7C7 8.85651 7.7375 10.637 9.05025 11.9497C10.363 13.2625 12.1435 14 14 14ZM11.5008 16.625C6.11406 16.625 1.75 20.9891 1.75 26.3758C1.75 27.2727 2.47735 28 3.37421 28H24.6258C25.5227 28 26.25 27.2727 26.25 26.3758C26.25 20.9891 21.8859 16.625 16.4992 16.625H11.5008Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPerson);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person.9e2dd56b9145cbb47fa81d22fd8a765f.svg";